import { render } from "./organization_dashboard.html?vue&type=template&id=352f9445&external"
import script from "./organization_dashboard.js?vue&type=script&lang=js&external"
export * from "./organization_dashboard.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__